/**
 * Le contact d'un document, sous la forme de l'option du <v-select> « people ».
 *
 * Les onglets d'édition (réception, vente, achat, facture, transport entrant,
 * fiche contact, et leurs variantes broker) chargent /people_name/data — les
 * contacts ACTIFS — puis retiraient de cette liste le contact du document :
 *
 *     const i = options.findIndex((p) => p.value === people[0].id);
 *     this.personId = options.splice(i, 1)[0];
 *
 * Quand le contact n'est plus actif, findIndex rend -1 et splice(-1, 1) retire
 * le DERNIER contact de la liste : c'est lui qui s'affichait, et lui qui
 * repartait au Save dans `idperson`. Comme /people_name/data n'a pas d'ORDER BY,
 * ce dernier contact est le plus récemment modifié en base. Mesuré le
 * 2026-10-26 : 26 réceptions MAGIC COSCHET (fournisseur sur le doublon
 * inactif « SC MAGIC COSCHET SRL » #1558) rattachées une à une au client
 * allemand #6572 en tapant leur numéro de facture.
 *
 * Ici : le contact du document reste le contact du document, même inactif ;
 * il est remis en tête de la liste pour rester visible ; aucun contact → null.
 *
 * Module ES, jamais `module.exports` : Babel injecte ici des imports de
 * polyfills (findIndex, splice…), webpack traite alors le fichier en module ES
 * et `module.exports` devient en lecture seule → le fichier plante au
 * chargement et les huit écrans qui l'importent restent vides (2026-10-26,
 * fiche contact broker). scripts/person-option.test.js retire les `export`.
 */
export function personLabel (p) {
  if (!p) return ''
  const company = (p.company_name || '').trim()
  const name = [p.firstname, p.lastname].filter(Boolean).join(' ').trim()
  if (p.iscompany === false) return name || company
  return company || name
}

/**
 * @param {Array<{value:number,label:string}>} options  la liste du <v-select>, modifiée en place
 * @param {{id:number,company_name?:string,firstname?:string,lastname?:string,iscompany?:boolean,isactive?:boolean}} person
 * @returns {{value:number,label:string,inactive?:boolean}|null}
 */
export function takePersonOption (options, person) {
  if (!Array.isArray(options)) return null
  if (!person || person.id === undefined || person.id === null) return null
  const index = options.findIndex((o) => o && o.value === person.id)
  if (index >= 0) return options.splice(index, 1)[0]
  const inactive = person.isactive === false
  const label = (personLabel(person) || `#${  person.id}`) + (inactive ? ' (inactive)' : '')
  const option = { value: person.id, label, inactive }
  options.unshift(option)
  return option
}
